module.exports = "/images/vendor/flag-icon-css/flags/4x3/fk.svg?519e3de544b46b3524a5a2bbbc383625";